export default "__VITE_ASSET__4a3d71f0__"